import signedFetch from '../util/signedFetch';

export default function* getCoursePublishStatusApi(publishId, publishType) {
  const URL = `${__API_BASE__}/content/course/publish/status?publishId=${publishId}&publishType=${publishType}`;
  return yield signedFetch('getCoursePublishStatusApi', URL, 'GET', null, null, false, true);
}
